export const defaultUrl = 'https://www.example.com';
export const urlPrefix = ['https://', 'http://'];
